import { connect } from 'react-redux'

import BondPositionsPane from '../components/BondPositionsPane'
import { RootState } from '../types/index'
import { TradingAction, togglePositions } from '../actions/'
import { closeBondTrade } from '../actions/TradeActions'
import { setModal } from '../actions/dialogActions'
import { I18n } from 'react-redux-i18n'
import { MT4Connector } from '@bdswiss/mt4-connector'
import { Dispatch } from 'redux'

const mt4 = MT4Connector.Instance

export function mapStateToProps(rootState: RootState) {
  const state = rootState.appState
  return {
    opened: state.positionsOpened,
    currency: state.currency,
    locale: rootState.appConfig.locale
      ? rootState.appConfig.locale
      : rootState.tradingAccounts.viewer.locale,
    assets: mt4.assets, // rootState.prices,
    // subscriptions: rootState.symbolsSubscriptions,
    positions: Array.from(mt4.positions.values()), // rootState.trades,
    bonds: mt4.bonds,
    viewer: rootState.tradingAccounts,
    tradingAccount: mt4.account, // rootState.tradingAccount,
    closedPosQuery: rootState.history,
    accountLoaded: state.accountLoaded,
    assetLoaded: state.assetLoaded,
    tradeOperationEnabled: rootState.tradingPane.tradeOperationEnabled,
  }
}

export function mapDispatchToProps(dispatch: Dispatch<TradingAction>) {
  return {
    onCloseTrade: (order: number, uuid?: string) =>
      dispatch(
        setModal(
          I18n.t(`closingPosition`),
          I18n.t('closePositionMessage'),
          closeBondTrade(order, uuid)
        )
      ),
    // onCloseAllTrades: () => dispatch(setModal(I18n.t(`closingPositions`), I18n.t("closeAllPositionsMessage"), closeAllTrades())),
    onToggleMenu: () => dispatch(togglePositions()),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BondPositionsPane)
